export const projectName = (string) => {
  return string.replaceAll('-', ' ');
};
